import React from "react";
import FilterList from "../../../components/user/users/userFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const UserListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

UserListPage.propTypes = {};

export default UserListPage;
